import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/_services';
import { passwordMatchingValidatior } from '@app/validators/passwordMatching.validator';
import { first } from 'rxjs/operators';

@Component({
  selector: 'password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.less']
})

export class PasswordResetComponent {
  newPasswordForm: FormGroup;
  token: any = '';
  error: string = '';
  loading: boolean = false;
  currentIndex: number = 0;
  validationMessages = {
    'newPassword': [
      { type: 'required', message: 'Password is required' },
      { type: 'minlength', message: 'The password must have at least 8 characters in length' },
      { type: 'pattern', message: 'Your password must contain at least one uppercase, one lowercase, a symbol, and one number' }
    ],
    'newPasswordRepeat': [
      { type: 'required', message: 'Please repeat your password' }
    ]
  };

  constructor(
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private router: Router,
    private formBuilder: FormBuilder
  ) { 
    this.newPasswordForm = this.formBuilder.group({
      newPassword: ['', Validators.compose([
                        Validators.required, 
                        Validators.minLength(8),
                        Validators.pattern("^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[#$@!%&*?])[A-Za-z\\d#$@!%&*?]{8,30}$")]
                        )],
      newPasswordRepeat: ['', Validators.required ]
    }, { validators: passwordMatchingValidatior } );
  }

  ngOnInit() {
    this.loading = true;
    this.route.paramMap.subscribe(params => {
        let token = params.get('token');
        if (token) { 
            this.token = token;
            this.authenticationService.validateResetPasswordToken(this.token)
              .pipe(first())
              .subscribe(
                  data => {
                    if (data.isValid) {
                      this.currentIndex = 1;
                    } else {
                      this.loading = false;
                      this.error = 'Invalid token';
                    }
                  },
                  error => {
                      console.log("error");
                      this.error = error;
                      this.loading = false;
                  });
        }
    });
  }

  
  onSetNewPassword() {
    if (this.newPasswordForm.invalid) {
      return;
    }

    this.loading = true;

    let form = this.newPasswordForm.getRawValue();
    form.token = this.token;
    this.authenticationService.resetUserPassword(form)
      .pipe(first())
      .subscribe(result => {
        this.authenticationService.logout();
        this.router.navigate(['/']);
      });
  }

}
